// src/components/Common/NotificationBanner.js
import React from 'react';
import { Alert, Button } from 'react-bootstrap';

const NotificationBanner = ({ message, variant = "warning", downloadUrl, onDismiss }) => {
  return (
    <Alert variant={variant} dismissible onClose={onDismiss} role="status">
      <Alert.Heading>{message}</Alert.Heading>
      <p>
        An AI-generated draft has been created from your uploaded curriculum. 
        As per academic governance policy, this draft requires mandatory SME review, editing, and approval before proceeding.
      </p>
      {downloadUrl && (
        <Button variant="outline-primary" href={downloadUrl} target="_blank">
          Download AI Draft for Review
        </Button>
      )}
    </Alert>
  );
};

export default NotificationBanner;
